import React from 'react';
import { OriginVisual } from './OriginVisual';

export const OriginRightImage = ({ down_type, origin, t, originExceptionFlag }) => {
  return (
    <OriginVisual origin={origin} down_type={down_type} lower="right" t={t} originExceptionFlag={originExceptionFlag} />
  );
};